import { isNumeric } from "vue-chess-shared/utils/number-helper";

const MoveHelper = {
  fullMoveCount(moves, blackToStart) {
    if (!moves || !moves.length) return 0;
    return Math.ceil((moves.length + (blackToStart ? 1 : 0)) / 2);
  },

  movesStats(match, moves, blackToStart) {
    if (!match) return [];
    if (!moves || !moves.length) return [];
    if (!moves[moves.length - 1].createdAt) return [];
    const matchCommencedAt =
      match.commencedAt || match.startedAt || match.createdAt;
    const startTimerIndex = match.tournamentId ? 0 : 2;
    const playersTimeUsed = [0, 0];
    const playersBufferUsed = [0, 0];
    const playersTimeLeft = [match.duration, match.duration];
    const playersBufferLeft = [
      match.buffer_duration || 0,
      match.buffer_duration || 0,
    ];

    return moves.map((m, i) => {
      const previousMoveCreatedAt = i
        ? moves[i - 1].createdAt
        : match.startedAt || match.createdAt;

      const s = {
        ...m,
        moveIndex: i,
        fullMoveNumber: (i + blackToStart) / 2,
        timeOffset: m.localTimestamp ? m.createdAt - m.localTimestamp : 0,
        e2eTime: Math.max(
          0,
          m.createdAt && previousMoveCreatedAt
            ? m.createdAt - previousMoveCreatedAt
            : 0
        ),
        sendTime: m.receivedAt ? m.receivedAt - m.createdAt : 0,
      };

      //color if not set
      if (!s.color) s.color = (i + blackToStart) % 2 ? "black" : "white";

      const lastMoveSendTime =
        i > 0 && moves[i - 1].receivedAt && moves[i - 1].createdAt
          ? moves[i - 1].receivedAt - moves[i - 1].createdAt
          : 0;

      // buffer time
      if (playersBufferLeft[i % 2] > 0 && i >= startTimerIndex) {
        s.bufferTime = Math.min(lastMoveSendTime, playersBufferLeft[i % 2]);
        playersBufferLeft[i % 2] -= s.bufferTime;
        playersBufferUsed[i % 2] += s.bufferTime;
      } else s.bufferTime = 0;

      // buffer used & left
      s.bufferUsed = playersBufferUsed[i % 2];
      s.bufferLeft = playersBufferLeft[i % 2];

      // actual move time
      s.actualMoveTime = i > 0 ? s.e2eTime - lastMoveSendTime : s.e2eTime;

      // move time
      s.moveTime =
        i >= startTimerIndex && m.createdAt > matchCommencedAt
          ? i > 0 || startTimerIndex > 0
            ? s.e2eTime - s.bufferTime
            : m.createdAt - matchCommencedAt
          : 0;

      // time used & left
      playersTimeUsed[i % 2] += s.moveTime;
      playersTimeLeft[i % 2] -= s.moveTime;

      // increment
      if (i >= startTimerIndex && isNumeric(match.increment)) {
        if (s.received || i < moves.length - 1) {
          // opponent has received the move
          s.increment = match.increment;
          playersTimeLeft[i % 2] += match.increment;
        }
      }

      s.timeUsed = playersTimeUsed[i % 2];
      s.timeLeft = playersTimeLeft[i % 2];

      return s;
    });
  },

  playerMoves(match, moves, blackToStart, firstMoveIndex) {
    if (!moves) return [];
    return this.movesStats(match, moves, blackToStart).filter(
      (_m, i) => (i + firstMoveIndex + 1) % 2
    );
  },

  whiteMoves(match, moves, blackToStart) {
    let a = this.playerMoves(match, moves, blackToStart, blackToStart ? 1 : 0);
    if (blackToStart) a = [null, ...a];
    return a;
  },

  blackMoves(match, moves, blackToStart) {
    return this.playerMoves(match, moves, blackToStart, blackToStart ? 0 : 1);
  },

  playerBufferTime(match, moves, firstMoveIndex) {
    if (!match) return 0;
    if (!match.buffer_duration) return 0;
    if (!match.commencedAt) return match.buffer_duration;
    const usedBufferDuration = this.playerMoves(
      match,
      moves,
      firstMoveIndex
    ).reduce(
      (rv, m) => (m.receivedAt ? rv + (m.receivedAt - m.createdAt) : rv),
      0
    );
    return Math.max(0, match.buffer_duration - usedBufferDuration);
  },

  whiteBufferTime(match, moves, blackToStart) {
    return this.playerBufferTime(match, moves, blackToStart ? 1 : 0);
  },

  blackBufferTime(match, moves, blackToStart) {
    return this.playerBufferTime(match, moves, blackToStart ? 0 : 1);
  },

  getPlayerTimers({
    timeTotal,
    timeUsed,
    bufferTotal,
    bufferUsed,
    moveTime,
    lastMove,
  }) {
    let bufferLeft = bufferTotal - bufferUsed;
    const moveBuffer = Math.min(
      bufferLeft,
      lastMove
        ? lastMove.receivedAt
          ? lastMove.receivedAt - lastMove.createdAt
          : moveTime
        : 0
    );
    bufferLeft -= moveBuffer;

    const actualMoveTime =
      lastMove && lastMove.receivedAt ? moveTime : moveTime - moveBuffer;

    const timeLeft = timeTotal - timeUsed - actualMoveTime;

    return {
      timeLeft,
      bufferLeft,
    };
  },
};

export default MoveHelper;
